import { Grid, Modal as ModalModule, UI } from 'common';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import React from 'react';
import DeleteCategoryModal from './DeleteCategoryModal.component';
import EditCategoryModal from './EditCategoryModal.component';
import ProductsCommunication from './utils/ProductsCommunication';

const { GridPanel } = Grid;
const { Spinner, WrappedToolbar } = UI;
const { Modal, ModalContext } = ModalModule;

class ManageCategoriesModal extends React.Component {
	constructor(props) {
		super(props);

		const {
			data: { categoryOptions = [] },
		} = props;

		this.state = {
			selectCategory: {},
			categoryOptions,
			columnDefs: [
				{
					headerName: 'Category',
					field: 'Name',
					sortable: false,
					cellRenderer: ({ node, value, data }) => {
						const { selectCategory } = this.state;
						const selected =
							!isEmpty(selectCategory) &&
							selectCategory.CategoryID === data.CategoryID;

						node.setSelected(selected);

						// Return a DOM node: ag-grid parses string results as HTML.
						const span = document.createElement('span');
						span.textContent = value;
						return span;
					},
				},
				{
					headerName: '# of Products',
					field: 'ProductCount',
					flex: 1,
					sortable: false,
				},
			],
			isLoading: false,
		};
	}

	addNewCategory = async name => {
		const { showError } = this.context;
		const response = await ProductsCommunication.addCategory({
			Active: true,
			Name: name,
		});

		if (!ProductsCommunication.isSuccessful(response)) {
			return showError({
				response,
			});
		}

		this.onUpdateSuccessful();
	};

	deleteCategory = async () => {
		const { showError } = this.context;
		const { selectCategory } = this.state;
		const response = await ProductsCommunication.deleteCategory(
			selectCategory.CategoryID
		);

		if (!ProductsCommunication.isSuccessful(response)) {
			return showError({
				response,
			});
		}

		this.onUpdateSuccessful();
	};

	editCategoryName = async name => {
		const { showError } = this.context;
		const { selectCategory } = this.state;
		const response = await ProductsCommunication.updateCategory({
			Active: selectCategory.Active,
			CategoryID: selectCategory.CategoryID,
			Name: name,
			SellerID: selectCategory.SellerID,
		});

		if (!ProductsCommunication.isSuccessful(response)) {
			return showError({
				response,
			});
		}

		this.onUpdateSuccessful();
	};

	onClickAddButton = () => {
		const { showModal } = this.context;
		const { categoryOptions } = this.state;

		showModal({
			component: EditCategoryModal,
			data: {
				categoryOptions,
				type: 'Add',
				onSaveCategoryCallback: this.addNewCategory,
			},
		});
	};

	onClickEditButton = () => {
		const { showModal } = this.context;
		const { selectCategory, categoryOptions } = this.state;

		showModal({
			component: EditCategoryModal,
			data: {
				categoryOptions,
				selectCategory,
				type: 'Edit',
				onSaveCategoryCallback: this.editCategoryName,
			},
		});
	};

	onClickDeleteButton = async () => {
		const { showModal } = this.context;
		const { selectCategory } = this.state;

		showModal({
			component: DeleteCategoryModal,
			data: {
				name: selectCategory.Name,
				onDeleteCallback: this.deleteCategory,
			},
		});
	};

	onSelectionChanged = (rowNodes = []) => {
		const node = rowNodes.length > 0 ? rowNodes[0] : {};
		const { data = {} } = node;

		this.setState({
			selectCategory: { ...data },
		});
	};

	onUpdateSuccessful = () => {
		const {
			data: { refreshCategoryOptionsCallback },
		} = this.props;

		this.setState({ isLoading: true });

		if (isFunction(refreshCategoryOptionsCallback)) {
			refreshCategoryOptionsCallback(categoryOptions => {
				this.setState({
					categoryOptions,
					isLoading: false,
				});
			});
		}
	};

	render() {
		const { modalId } = this.props;
		const { selectCategory, categoryOptions, columnDefs, isLoading } =
			this.state;
		const categoryID = selectCategory ? selectCategory.CategoryID : null;
		const buttons = [
			{
				label: 'Add',
				icon: 'add-icon',
				dataqa: 'add-new-category',
				disabled: isLoading,
				onClick: this.onClickAddButton,
			},
			{
				label: 'Edit',
				dataqa: 'edit-category',
				disabled: isLoading || !categoryID,
				onClick: this.onClickEditButton,
			},
			{
				label: 'Delete',
				dataqa: 'delete-category',
				disabled: isLoading || !categoryID,
				onClick: this.onClickDeleteButton,
			},
		];

		return (
			<Modal
				modalId={modalId}
				className="products products-manage-categories-modal"
				header="Manage Categories"
				size="small"
				hideFooter
			>
				<WrappedToolbar buttons={buttons} dataqa="manage-categories-toolbar" />
				<GridPanel
					className="manage-categories-grid"
					columnDefs={columnDefs}
					domLayout="autoHeight"
					rowData={categoryOptions}
					showPagination={false}
					rowSelection="single"
					dataqa="manage-categories-grid"
					onSelectionChanged={this.onSelectionChanged}
				/>
				{isLoading ? <Spinner msg="Updating Categories" /> : null}
			</Modal>
		);
	}
}
ManageCategoriesModal.contextType = ModalContext;

export default ManageCategoriesModal;
